export default {
	waiting: 'locations/:locationId/tickets/changed-waiting-number',
	called: 'locations/:locationId/tickets/called'
}
